import { OrderPromotionType } from '~/graphql/operations'
import { BaseSelect } from '../../model'

type PromotionTypeMarker = {
  label: string
  badge: 'attention' | 'processing' | 'success'
}

export const orderPromotionTypes: Record<
  OrderPromotionType,
  PromotionTypeMarker
> = {
  [OrderPromotionType.Promo]: { label: 'Promo', badge: 'attention' },
  [OrderPromotionType.Multibuy]: { label: 'Multibuy', badge: 'processing' },
  [OrderPromotionType.Coupon]: { label: 'Coupon', badge: 'success' },
}

export class OrderPromotionTypeSelect extends BaseSelect {
  name = 'promotionTypes'
  label = 'Promotion Type'
  placeholder = 'Select promotion type'

  options() {
    return [
      ...Object.entries(orderPromotionTypes).map(([value, { label }]) => ({
        value,
        label,
      })),
      { value: 'none', label: 'No promotion' },
    ]
  }
}
